/**
 * Where a control's hover hint belongs — `data-tooltip` (TooltipHost) or the
 * native `title`.
 *
 * Its own module, not part of `@papan/core-ui/ui`: that barrel is replaced
 * wholesale by `vi.mock` in dozens of component suites, and a helper called
 * during render must not make every one of them fail on a missing export.
 */
/** Hint attributes for a control that MAY be disabled.
 *
 *  A disabled form control dispatches no pointer events, so TooltipHost never
 *  sees a hover on it and `data-tooltip` silently shows nothing — exactly when
 *  the hint tends to be the sentence explaining why the control is greyed out
 *  ("All triggers are already running"). The native tooltip still renders on a
 *  disabled control, so the hint is routed there instead. Never both at once:
 *  an element carrying `title` AND `data-tooltip` shows two bubbles.
 *
 *  Spread it: `<button {...hintAttrs(text, busy)} …>`. Controls built on
 *  `ToolbarControls` already do this for you. */
export function hintAttrs(
  text: string | undefined,
  disabled?: boolean,
): { title?: string; 'data-tooltip'?: string } {
  return disabled ? { title: text } : { 'data-tooltip': text }
}
